// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"892":"css/app.6772","8851":"css/admin-app.6772"}[chunkId] + ".css";
};